/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import { Autoplay, Navigation, Pagination } from "swiper";
import Swiper from "swiper";
Swiper.use([Autoplay, Navigation, Pagination]);

import Vue from 'vue'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/es'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, { locale });

import VueMq from 'vue-mq'
Vue.use(VueMq, {
    breakpoints: {
        sm: 640,
        md: 768,
        lg: 1280,
        xl: 1600,
    },
})
window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.component('initial-loading', require('./components/Utils/InitialLoading.vue').default);
Vue.component('user-profile', require('./components/User/Profile.vue').default);
Vue.component('product-detail', require('./components/Catalog/ProductDetail.vue').default);
Vue.component('shopping-cart', require('./components/Shpping-cart/ShoppingCart.vue').default);
Vue.component('shopping-cart-header', require('./components/Shpping-cart/ShoppingCartHeader.vue').default);
Vue.component('learning-index', require('./components/Learning/LearningIndex.vue').default);
Vue.component('learning-content', require('./components/Learning/LearningContent.vue').default);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
